import React from "react";
import { useSelector } from "react-redux";

import * as selectedLeveeEditRedux from "../state/existingLeveeEditsMenu";
import { getSelected } from "../state/existingRasterEditsMenu";
import {
  getActiveSelectionType,
  getActiveTool,
  getRightCollapsableSidebarVisible,
} from "../state/mainGui";
import { getLineDataStatus } from "../state/mapProfileLine";
import { getSelectedAsset } from "../state/selectedAsset";
import { getDemValue, getGridcell, getGroundwaterGridcell } from "../state/selectedPoint";

import styles from "./MainScreen.module.css";
import NoData from "./NoData";
import ProfileInspector from "./ProfileInspector";
import SelectedAssetInspector from "./SelectedAssetInspector";
import SelectedLeveeEditInspector from "./SelectedLeveeEditInspector";
import SelectedPointInspector from "./SelectedPointInspector";
import SelectedRasterEditInspector from "./SelectedRasterEditInspector";

const RightCollapsableSidebar = () => {
  const activeTool = useSelector(getActiveTool);
  const activeSelectionType = useSelector(getActiveSelectionType);
  const lineDataStatus = useSelector(getLineDataStatus);
  const selectedAsset = useSelector(getSelectedAsset);
  const selectedRasterEdit = useSelector(getSelected);
  const selectedLeveeEdit = useSelector(selectedLeveeEditRedux.getSelected);
  const pointGridcell = useSelector(getGridcell);
  const pointGroundwaterGridcell = useSelector(getGroundwaterGridcell);

  const sidebarVisible = useSelector(getRightCollapsableSidebarVisible);
  const demValue = useSelector(getDemValue);

  const showProfileTool = activeSelectionType === "LINE_SELECTION" && lineDataStatus;
  const showSelection = selectedAsset && activeSelectionType === "SELECTION";
  const showPointInspector =
    (pointGridcell || pointGroundwaterGridcell) && demValue !== null && demValue !== -9999;

  const showRasterEdit = activeTool === "RASTER_EDIT" && selectedRasterEdit;
  const showLeveeEdit = selectedLeveeEdit;

  /*
  Below part ads the class collapsed_right_sidebar to the leaflet zoom buttons
  This class makes sure this element is moved to the right together with the leftcollaapsable sidebar.
  Previously we did not add this and the collapsable sidebar would fall over the zoom buttons.
  The other part of the relevant code is in index.css
  */
  const elements = document.querySelectorAll(".maplibregl-control-container");
  if (elements[0]) {
    if (sidebarVisible) {
      elements[0].classList.add("collapsed_right_sidebar");
    } else {
      elements[0].classList.remove("collapsed_right_sidebar");
    }
  }

  return (
    <div
      className={`
      ${styles.RightCollapsableSidebar}
      ${styles.CollapsableSidebar}
      ${sidebarVisible ? styles.Visible : undefined}
    `}
    >
      {showRasterEdit ? (
        <SelectedRasterEditInspector />
      ) : showLeveeEdit ? (
        <SelectedLeveeEditInspector />
      ) : showProfileTool ? (
        <ProfileInspector />
      ) : showPointInspector ? (
        <SelectedPointInspector asset={pointGridcell} groundwaterAsset={pointGroundwaterGridcell} />
      ) : showSelection && selectedAsset ? (
        <SelectedAssetInspector asset={selectedAsset} />
      ) : (
        <NoData /> // Should only be called when point has no data or is still loading
      )}
    </div>
  );
};

export default RightCollapsableSidebar;
